import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueCarousel from 'vue-carousel';

Vue.use(VueCarousel);

import Slick from 'vue-slick';


Vue.config.productionTip = false

import ContentBlocks from 'contentblocks-vuejs'
Vue.use(ContentBlocks, {project_id: 'a8ccPuZAblehT7CR4Ai1' })


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
